export default __webpack_public_path__ + "static/media/romansch_grisons.905695f3.xlsx";